import React, { Fragment, useState, useEffect, useRef, useContext } from "react";
import { Howl } from 'howler';

import JobCard from "./jobCard";
import { Box, CircularProgress } from '@mui/material';
import AppContext from '../context/AppProvider';
import { useHistory } from 'react-router-dom';

import newJobNotifySound from "../audioClips/new_job_notify.mp3";

import { useLazyJobsForUserQuery } from '../services/jobsApi';

import BasicModalInformation from "./basicModalInformation";
import { useClaimJobMutation } from "../services/jobsApi"
import { useSelector } from "react-redux";
import { selectCurrentUser } from "../features/auth/authSlice";
import SignalREncorehiveContext from "../context/signalREncorehive";
import useUserTypes from "../customHooks/useUserTypes";

function eventsToDict(events) {
  let r = {};
  events.forEach(event => {
    if (event.success) {
      let eventId = event.eventModel.bteId;
      r[eventId] = event.eventModel;
    }
  })
  return r;
}

function showJobs(jobs, props) {
  return jobs.map((job, index) => {
    let jobsIsDisabled = job.jobsIsDisabled;
    return (
      <JobCard
        key={job.id}
        job={job}
        {...props}
        jobsIsDisabled={jobsIsDisabled}
        className="item"
      />
    );
  });
}

var sound = new Howl({
  src: [newJobNotifySound]
});

function JobList(props) {
  const { config, setCurrentJob, setNotificationsCount } = useContext(AppContext);
  const { signalREncorehive:signalRConnection  } = useContext(SignalREncorehiveContext);
  
  const user = useSelector(selectCurrentUser);

  const [initClaimJob, {isLoading: claimJobIsLoading}] = useClaimJobMutation();

  const [getJobList] = useLazyJobsForUserQuery();

  let connection = signalRConnection;
  const [jobList, setJobList] = useState(null);
  const [errorNotification, setErrorNotification] = useState(false);
  const [error, setError] = useState(null);
  const userTypes = useUserTypes();

  const lastJobsList = useRef(null);
  const disableList = useRef(false);
  const history = useHistory();
  const lastUser = useRef(null);

  lastJobsList.current = jobList;
  lastUser.current = user;

  useEffect(() => {
    console.log("useEffect config: ", JSON.stringify(config));
    console.log("useEffect jobList: ", jobList?.length);
    console.log("useEffect user: ", user?.id);

    if (!user.id || jobList == null || !config) {
      console.log("useEffect aborting because of null values: ", user.id, jobList, config);
      return;
    }
    if (jobList.length == 0) {
      console.log("useEffect aborting because of jobList.length == 0: ", jobList.length);
      return;
    }
    if (user.role == "Admin") {
      console.log("useEffect aborting because of user.role==Admin: ", user.role);
      return;
    }

    disableList.current = disableListValidation()
  }, [config, jobList, user, userTypes]);

  function disableListValidation(){

    let enableJobClaiming = config.find(x => x.name === "enableJobClaiming")?.value;
    let DisableDistributionForSwarm = config.find(x => x.name === "DisableDistributionForSwarm")?.value;
    let newBeeId = userTypes?.find(x => x.name === "NewBee")?.id;

    // DEBUG: log enableJobClaiming, DisableDistributionForSwarm, newBeeId user.role and user.userTypeId
    console.log("useEffect enableJobClaiming: ", enableJobClaiming);
    console.log("useEffect DisableDistributionForSwarm: ", DisableDistributionForSwarm);
    console.log("useEffect newBeeId: ", newBeeId);
    console.log("useEffect user.role: ", user.role);
    console.log("useEffect user.userTypeId: ", user.userTypeId);
    console.log("useEffect userTypes: ", userTypes);

    if(enableJobClaiming == false || DisableDistributionForSwarm == true){
      console.log("useEffect disable list because of enableJobClaiming == ", enableJobClaiming, "DisableDistributionForSwarm == ", DisableDistributionForSwarm);

      if(DisableDistributionForSwarm == true && (user.role == "Admin" ||user.userTypeId == newBeeId)){
        console.log("user allowed to claim jobs")
        return false
      }else if(enableJobClaiming == false && user.role == "Admin"){
        console.log("user allowed to claim jobs")
        return false
      }

      return true;
    }
    else{
      console.log("useEffect aborting because of enableJobClaiming == ", enableJobClaiming, "DisableDistributionForSwarm = ", DisableDistributionForSwarm);
      
      return false
    }
  }

  function disableAllJobs(disable=true){
    if(!jobList) return;
    setJobList(prev => prev?.map(x => ({ ...x, jobsIsDisabled: disable })));
  }

  async function onClaimClick(jobClaiming) {
    //A: set all jobs as disabled, to avoid that the user can claim more than one job
    disableAllJobs();
    try {

      // const res= await connection.invoke("Claim", {EncoreHiveUserId: user.id, JobId: jobClaiming.id});
      const res = await initClaimJob({jobId:jobClaiming.id, userId:user.id}).unwrap();
      console.log("Claim Job Res: ", res);
      if (res.status === "Ok") {
        console.log("JobClaimedSuccessfully:");
        console.log(jobClaiming);
        let jobId = jobClaiming.id;
        setCurrentJob({ ...res.res.job, ...res.res.event.eventModel });
        history.push("/dashboard/job/" + jobId)
      }
      else {
        console.log("Job claimed error res: " + JSON.stringify(res));
        let defaultMessage = "The job is no longer available";
        var jobClaimed = res.message == "Job already claimed";
        setErrorNotification(jobClaimed ? defaultMessage : res.message);
      }

    } catch (error) {
      console.log("Job claimed error res: ", error)
      if (error.statusCode == 403) {
        setErrorNotification(error.message);
      }
    }
  }

  async function getAvailableJobs() {
    console.log("getAvailableJobs, init lastUser.current.id: " + JSON.stringify(lastUser.current?.id));
    if (!lastUser.current || Object.keys(lastUser.current).length == 0) return
    // let response = await connection.invoke("GetAvailableJobs", { "JobStatus": "Active",availableForThisUserId: lastUser.current.id});

    let response;
    try {
      response = await getJobList().unwrap();
    } catch (error) {
      console.log("getAvailableJobs_2 error: " + JSON.stringify(error))
      if (error.status == 401) return; //error managed on baseQueryWithReauth
      throw error;
    }
    if (!response) return;
    let res = response.res;
    console.log("getAvailableJobs")
    console.log(console.log(response));
    if (response.status === "Ok") {
      let eventsObj = res.events; //A: get obj from string response
      let eventsDict = eventsToDict(eventsObj); //A: dictionar to fast index;

      let jobs = res.jobs.reduce((pV, oneJob) => {
        let eventInfo = eventsDict[oneJob.eventId];
        if (eventInfo)
          pV.push({ ...oneJob, ...eventsDict[oneJob.eventId] });
        return pV;
      }, []);

      console.log("JOBS AVAIALABLE RESPONSE: ");
      console.log(jobs)
      setJobList(jobs);
      return jobs;
    }
    if (response.status == "Failed") {
      setError(true);
      throw new Error("Error on getAvailableJobs: " + JSON.stringify(response));
    }
  }

  async function getAvailableJobs_2() {
    if (!user || !user.id) return
    console.log("invoking getAvailableJobs_2 user: " + JSON.stringify(user))
    let response;
    try {
      response = await getJobList().unwrap();
    } catch (error) {
      console.log("getAvailableJobs_2 error: " + JSON.stringify(error))
      if (error.status == 401) return; //error managed on baseQueryWithReauth 
      throw error;
    }
    if (!response) return;
    let res = response.res;
    console.log("getAvailableJobs")
    console.log(console.log(response));
    if (response.status === "Ok") {
      let eventsObj = res.events; //A: get obj from string response
      let eventsDict = eventsToDict(eventsObj); //A: dictionar to fast index;

      let jobs = res.jobs.reduce((pV, oneJob) => {
        let eventInfo = eventsDict[oneJob.eventId];
        if (eventInfo)
          pV.push({ ...oneJob, ...eventsDict[oneJob.eventId] });
        return pV;
      }, []);

      console.log("JOBS AVAIALABLE RESPONSE: ");
      console.log(jobs)
      return jobs;
    }
  }

  useEffect(() => {

    function setJobAsDisabled(jobId) {
      let updatedJobList = [...lastJobsList.current];
      updatedJobList = updatedJobList.map((job) => {
        if (job.id === jobId)
          job.jobsIsDisabled = true;
        return job;
      });

      setJobList(updatedJobList);
    }

    if (connection) {

      connection.on('enableOrDisableJobClaiming', function (enableJobClaiming) {
        console.log('signalR, (jobList) new notification for enableOrDisableJobClaiming newValue: ' + enableJobClaiming);
        if (enableJobClaiming == 'false') {
          console.log("signalR, (jobList) enableOrDisableJobClaiming is false aborting");
          //A: we let the useEffect to handle the jobListIsDisabled
          return;
        }
        console.log("signalR, (jobList) enableOrDisableJobClaiming is true getting jobs");
        getAvailableJobs();
      });

      connection.on("GetAvailableJobs", function (res) {
        let eventsObj = res.events; //A: get obj from string response
        console.log("eventsObj: " + JSON.stringify(eventsObj));
        let eventsDict = eventsToDict(eventsObj); //A: dictionar to fast index;
        let jobs = res.jobs.map(oneJob => {
          return { ...oneJob, ...eventsDict[oneJob.eventId] };
        })
        console.log("JOBS AVAIALABLE RESPONSE: ");
        console.log(jobs)
        setJobList(jobs);
      });

      connection.on("JobClaimedFailed", function (jobId) {
        console.log("JobClaimedFailed:");
        console.log(jobId);
        alert("Job claime failed:" + jobId);
      });

      connection.on("JobClaimed", function (jobId, clientId) {
        console.log("Job:" + JSON.stringify(jobId) + " claimed by " + clientId);

        setJobAsDisabled(jobId);
        if (user && parseInt(user?.id || 0) == parseInt(clientId)) {
          props.onMyClaim(false);
        }
      });

      connection.on("JobEscalationResolved", (res) => {
        if (disableList.current) return;
        console.log("----------------------------------------------------------")
        console.log("                    ESCALATION WORKS                      ", res)
        getAvailableJobs();
        console.log("----------------------------------------------------------")
      })

      connection.on("HardEscalate", (jobId) => {
        let jobIsInList = lastJobsList?.current.find(job => Number(job.id) === Number(jobId))
        if (jobIsInList) {
          setJobAsDisabled(jobId)
        }
      })
      //A: an active job

      async function filterJob(newJob) {

        //check that lastJobsList.current is not empty, is an array and has elements
        if (lastJobsList.current && Array.isArray(lastJobsList.current)) {
          let jobExists = lastJobsList.current.find(x => x.id == newJob.id);
          if (jobExists) {
            console.log("job exists in list, DROP: " + newJob.id);
            return;
          }
          //A: first validation for job exists in list.

          let jobs = await getAvailableJobs_2();
          if (!jobs || !Array.isArray(jobs)) return;

          let result = jobs.filter(job => job.id == newJob.id)[0];
          if (result) {
            let job = result; //A: result if the job information + event information. newJob dont have the event information.
            let jobExists = lastJobsList.current.find(x => x.id == job.id);
            if (jobExists) {
              console.log("job exists in list, DROP: " + job.id);
              return;
            }
            //A: second validation if job exists in list

            if (job.status.name === "Active") {
              let updatedJobList = [...lastJobsList.current, job];
              setJobList(updatedJobList);
            }
            console.log("playing sound");
            sound.play();
            setNotificationsCount(prevCount => prevCount + 1);
          } else {
            console.log("the job is not in the available jobs for the users");
          }
        }
      }

      connection.on("NewJobEvenDistribution", async function (jobObj) {
        console.log("on NewJobEvenDistribution, disableList.current: " + disableList.current);
        if (disableList.current) return;
        console.log("--------------------------------------------------------");
        console.log("new job from evenDistribution jobId: " + jobObj.job.id + " , for userId: " + jobObj.userId);
        if (jobObj.userId == user?.id) {
          await filterJob(jobObj.job);
        } else {
          console.log("job from evenDistribution DROP, jobId: " + jobObj.job.id + "for userId: " + jobObj.userId + " , currentUser: " + user?.id);
        }
      });

      connection.on("NewJob", async function (res) {
        console.log("on NewJob, disableList.current: " + disableList.current);
        if (disableList.current) return;
        filterJob(res.res);
      });

      connection.on("BlackListEdited", async function (res) {
        let userId = Array.isArray(res) && res.length > 0 ? res[0].userId : null;
        console.log("BlackListEdited edited for userId: " + userId + " , currentUser: " + lastUser.current?.id);
        if (lastUser.current && lastUser.current.id == userId) {
          console.log("BlackListEdited edited for current user refreshing jobs");
          getAvailableJobs();
        }
      });
    }
  }, [connection, user]);

  useEffect(() => getAvailableJobs(), [props.reRender]); //A: this useEffect load the jobsList the first time, and when the user click on the refresh button

  return (

    <div className="jobs-list">
      {error}
      {jobList === null ? (
        !error && <CircularProgress />
      ) : jobList.length === 0 ? (
        <h3>No jobs found</h3>
      ) : (
        <Fragment>
          {showJobs(jobList?.map(x => ({ ...x, jobsIsDisabled: x.jobsIsDisabled || disableList.current })), { ...props, onClaimClick })}
        </Fragment>
      )}

      <BasicModalInformation
        title={errorNotification}
        open={errorNotification ? true : false}
        handleClose={() => { window.location.reload() }}
      />

      {error ? <h4>Error fetching data</h4> : null}
      
      </div>

  );
}

export default JobList;
